import { Injectable } from '@angular/core';
import { Select, TextBox } from '@mapfre-design-library/src/public_api';
import { Constants } from '@models/constants';

@Injectable({
  providedIn: 'root'
})
export class FormBaseInputsService {

  getZipCodeInput() {
    return new TextBox({
      additionalClasses: Constants.FORM_CONTROL,
      inputType: 'bank',
      key: 'makePayment_zip',
      label: 'ZIP code',
      required: true,
      type: 'tel',
      maxLength: 5,
      minLength: 5,
      validationMessageError: 'Invalid ZIP code',
    })
  }
  getAddPolicyInput() {
    return new TextBox({
      additionalClasses: Constants.FORM_CONTROL,
      inputType: 'text',
      key: 'addPolicy',
      label: 'Policy number',
      required: true,
      type: 'text',
      maxLength: 13,
      minLength: 6,
      validationMessageError: 'VALID_POLICY_VALIDATION_MESSAGE',
    })
  }
  getInputTextBox(inputType, key, label, type) {
    return new TextBox({
      additionalClasses: Constants.FORM_CONTROL,
      inputType: inputType,
      key: key,
      label: label,
      type: type,
    })
  }
  getInputSelectBox(inputType, key, label, type) {
    return new Select({
      additionalClasses: Constants.FORM_CONTROL,
      inputType: inputType,
      key: key,
      label: label,
      type: type,
    })
  }
  getTextBoxInput(inputType, key, label, type) {
    return new TextBox({
      additionalClasses: Constants.FORM_CONTROL,
      inputType,
      key,
      label,
      type,
    })
  }
  getCurrentDate() {
    const dtToday = new Date();
    let month: any = dtToday.getMonth() + 1;
    let day: any = dtToday.getDate();
    const year = dtToday.getFullYear();

    if (month < 10) {
      month = '0' + month.toString();
    }
    if (day < 10) {
      day = '0' + day.toString();
    }
    return `${year}-${month}-${day}`;
  }
}
